/**
 * Mock 模块：prob_gift_act_home
 * 入口倒计时对齐稿面 3D 12:00；VRT `prize_pool=0`（只出倒计时）。
 * @see mockMd/prob_gift_act_home.md
 */
import type {ProbGiftActHomeData} from '../types'

/** 3 天 12 小时 */
const MOCK_COUNTDOWN_SEC = 3 * 24 * 3600 + 12 * 3600

/** @see mockMd/prob_gift_act_home.md */
export const ProbGiftActHomeMock: ProbGiftActHomeData = {
  err_msg: '',
  phase: 0,
  countdown_sec: MOCK_COUNTDOWN_SEC,
  prize_pool: 0,
  my_score: 1000000000,
  my_rank: 4,
  rank_display: '4',
  gap_to_top3: 1000,
  estimate_coins: 0,
  estimate_ratio: 0,
  divide_ratio_text: '5:3:2',
  score_per_coin: 10,
  can_join: true,
  play: [1, 2],
  config_id: 1,
  warmup_st: 0,
  act_st: 0,
  act_et: 0,
  review_et: 0,
  b_gift_id: 0,
  room_id: 0,
  score_tasks: [],
}
